export default __webpack_public_path__ + "static/media/team2.300fe6a5.png";